import { Route } from '@angular/router';
import { RoleGuard } from './shared/guards/role.guard';

/**
 * Wraps a route so it requires an authenticated user and runs the RoleGuard.
 *
 * Redirect-only routes (e.g. the #1503 phms/home -> phms/dashboard redirect) are returned untouched:
 * Angular rejects redirectTo + canActivate (NG04014) because redirects run before guards. The
 * redirect target is itself protected, so nothing becomes reachable unauthenticated.
 *
 * Kept in its own module (rather than app.routes.ts) so it can be unit-tested without importing the
 * app route table, whose showcase imports depend on a generated file that is absent in CI.
 */
export const protectRoute = (route: Route): Route => {
    if (route.redirectTo !== undefined) {
        return route;
    }
    return {
        ...route,
        canActivate: [RoleGuard],
        data: {
            requireAuthenticated: true,
            ...(route.data ?? {}),
        },
    };
};
